"use strict";

import feather from 'feather-icons';
import { initDashboadGuestsListEvents } from './admin-dashboad-guests-list.js';
import { initSchedule } from './schedule.js';
import { initTables } from './tables.js';

export async function initDashboadEvents(admin) {
  initSchedule();
  initDashboadGuestsListEvents(admin);
  initTables();
  document.getElementById('tables-tab').addEventListener('click', () => {
    feather.replace();
  });
}
